import { render, staticRenderFns } from "./TransplantSurgery.vue?vue&type=template&id=37ca95e6"
import script from "./TransplantSurgery.vue?vue&type=script&lang=js"
export * from "./TransplantSurgery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports